module.exports = __webpack_public_path__ + "static/media/hackaton-3d-menu.9f774534.svg";